import type { FC } from 'react'

import type { DeprecatedDialogProps } from '../Dialog/DeprecatedDialog'
import { DeprecatedDialog } from '../Dialog/DeprecatedDialog'
import type { ModalProps } from '../Modal/Modal'
import { Modal } from '../Modal/Modal'
// import Debug from 'debug'
// const debug = Debug('jotta:ui:modal')

export type ModalDialogProps = ModalProps & DeprecatedDialogProps

export const ModalDialog: FC<ModalDialogProps> = ({
  open = false,
  onClose,
  disableBlur,
  ...props
}) => (
  <Modal open={open} onClose={onClose} disableBlur={disableBlur}>
    <DeprecatedDialog onClose={onClose} {...props} />
  </Modal>
)
